import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana63Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_23552)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M657.736 429.751L684.52 359.812L602.678 407.43L627.975 449.095L657.736 429.751Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M699.397 325.586L684.517 359.811L650.291 379.155L627.971 340.466L683.028 310.705C697.314 308.324 699.893 319.634 699.397 325.586Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M575.891 368.74L627.972 340.467L650.293 379.156L598.211 410.405L575.891 368.74Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M526.781 397.013L575.887 368.74L598.208 410.406L549.102 438.679L526.781 397.013Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M578.867 478.858L627.973 449.097L602.676 407.432L553.57 435.705L578.867 478.858Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M529.761 508.614L578.867 478.853L553.57 435.699L502.977 465.46L529.761 508.614Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M477.678 425.281L526.783 397.008L549.104 438.673L499.998 466.946L477.678 425.281Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M430.053 453.556L477.67 425.283L499.991 466.949L453.862 495.221L430.053 453.556Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M479.17 538.375L529.764 508.614L502.979 465.461L453.873 495.222L479.17 538.375Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M428.562 568.137L479.156 538.376L453.859 495.223L403.266 524.984L428.562 568.137Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M382.445 483.32L430.063 453.559L453.872 495.224L404.766 523.497L382.445 483.32Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M379.469 596.411L428.575 568.138L403.278 524.984L355.66 553.257L379.469 596.411Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M333.34 513.081L382.445 483.32L404.766 523.498L357.149 553.259L333.34 513.081Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M331.849 626.172L379.467 596.411L355.658 553.258L305.064 583.019L331.849 626.172Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M284.236 542.841L333.342 513.08L357.151 551.769L306.557 581.53L284.236 542.841Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M244.056 568.141L284.233 542.844L306.552 583.021L257.446 614.27C252.983 607.326 243.163 591.652 239.592 584.509C236.02 577.366 241.08 570.621 244.056 568.141Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M294.645 647.002L331.846 626.169L305.061 584.504L257.443 614.265C261.411 621.705 270.538 638.074 275.3 644.026C280.062 649.978 290.18 648.49 294.645 647.002Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_23552"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_23552"
            transform="matrix(0.00204111 0 0 0.00270596 -2.67629 -2.34207)"
          />
        </pattern>
        <image
          id="image0_1466_23552"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
